import React from 'react'
import { getFormattedDateAndTime } from '@modmd/data'
import { DEVICE } from 'theme'
import { useIsMaxDevice } from 'utils/hooks/useMedia'
import { Box } from 'components/Layout'
import Datalist from 'components/Datalist'
import Card from 'components/Card'
import { COMMON_BOTTOM_CONTENT_HEIGHT, CommonProps as Props } from '../common'
import { SectionTitle } from './SectionTitle'

export const PreviousTests: React.VFC<Props> = ({ driveThroughForm }) => {
  const isTabletOrMobile = useIsMaxDevice(DEVICE.DESKTOP)

  const { values } = driveThroughForm

  return (
    <Box pb={COMMON_BOTTOM_CONTENT_HEIGHT}>
      <SectionTitle isTabletOrMobile={isTabletOrMobile}>Previous Tests</SectionTitle>
      {values.previousTests.length > 0 && (
        <Card>
          <Datalist
            data={values.previousTests}
            renderTableHeader={() => (
              <Datalist.Row display="grid" gridTemplateColumns="repeat(3, 1fr)">
                <Datalist.HeaderCell label="date" />
                <Datalist.HeaderCell label="test type" />
                <Datalist.HeaderCell label="volume" />
              </Datalist.Row>
            )}
            shouldRenderTableHeader
            renderTableRow={({ date, testType, volume }) => (
              <Datalist.Row display="grid" gridTemplateColumns="repeat(3, 1fr)">
                <Datalist.Cell label="date">{date && getFormattedDateAndTime(date)}</Datalist.Cell>
                <Datalist.Cell label="test type">{testType}</Datalist.Cell>
                <Datalist.Cell label="volume">{volume}</Datalist.Cell>
              </Datalist.Row>
            )}
          />
        </Card>
      )}
    </Box>
  )
}
